import React, { useState, useEffect, useRef } from "react";

import api from "../services/api";

//components
import Popup from "../components/Popup";
import CopyBox from "../components/CopyBox";
import LogoMenu from "../components/LogoMenu";
import ErrorInternet from "../components/ErrorInternet";
import LoadingCenter from "../components/LoadingCenter";
import SwitchCheckbox from "../components/Forms/SwitchCheckbox";

//Feather
import {
  Power, User, UserCheck, UserPlus,
  UserX, Users, PieChart, MessageSquare,
  Edit2, Star, BookOpen, Mail, AlertTriangle, Briefcase, Moon, Send, BarChart2, Phone
} from "react-feather";

import { useAuth } from "../providers/auth";
import { useTheme } from "../hooks/useTheme";
import { NavLink, useNavigate } from "react-router-dom";
import Todo from "../components/TodoList/Todo";
import Gavel from "../svgs/Gavel";
import { CButton, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";
import PopupOutOfDateCustomers from "../components/PopupOutOfDateCustomers";

function Template(props) {
  const navigate = useNavigate();
  const newContact = useRef(null);
  const { user, setUser } = useAuth();
  const { theme, switchTheme } = useTheme();

  const [users, setUsers] = useState([]);
  const [qtdUsers, setQtdUsers] = useState("");
  const [infoLoading, setInfoLoading] = useState(false);
  const [buttonPopupNewContact, setButtonPopupNewContact] = useState(false);

  const handleSignOut = () => {
    setUser({ name: "", token: "" });
    localStorage.removeItem("user");
    navigate("/", { replace: true });
  }

  const newContactEmail = async () => {
    setButtonPopupNewContact(true);

    try {
      setInfoLoading(true);
      const response = await api.get(`/emailform/list`, { headers: { "Authorization": "Bearer " + user.token } });
      setUsers(response.data.data);
    } catch (error) {
      console.log("[FETCHING CHATS SAYS]:", error);
    } finally {
      setInfoLoading(false);
    }
  }

  const getOthersUsers = async () => {
    try {
      const response = await api.get("/users/others", { headers: { "Authorization": "Bearer " + user.token } });
      setQtdUsers(response.data[0].qtd);
    } catch (error) {
      console.log("[FETCHING CHATS SAYS]:", error);
    }
  }

  async function setUpdateView() {
    const options = { headers: { "Authorization": "Bearer " + user.token } };
    try {
      const response = await api.post("/admins/last/view", {}, options);
    } catch (error) {
      console.log(error);
    }
  }

  async function verificaContatoEmail() {
    try {
      const response = await api.get("/emailform/verify", { headers: { "Authorization": "Bearer " + user.token } });
      if (response.data > 0) {
        newContact.current = response.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getLongPollingEmail = async () => {
    verificaContatoEmail();

    setTimeout(() => {
      getLongPollingEmail();
    }, 15000);
  }

  //abrir dados em outros usuários
  useEffect(() => {
    getOthersUsers();
    getLongPollingEmail();
  }, []);

  const [trigger, setTrigger] = useState(false);

  return (
    <div className="main" data-theme={theme}>
      <Popup height="500" width="600" title="Novos contatos" trigger={buttonPopupNewContact} setTrigger={setButtonPopupNewContact}>
        {infoLoading ? (
          <LoadingCenter />
        ) : (
          <table>
            <thead>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  <span className="text-color">Nome</span>
                </td>
                <td style={{ fontWeight: "bold" }}>
                  <span className="text-color">Mensagem</span>
                </td>
                <td style={{ fontWeight: "bold" }}>
                  <span className="text-color">Telefone</span>
                </td>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => <CopyBox key={index} user={user} />)}
            </tbody>
          </table>
        )}
      </Popup>

      <PopupOutOfDateCustomers trigger={trigger} setTrigger={setTrigger} />

      <div className="nav">
        <div className="border-right header el-center">
          <LogoMenu />
        </div>

        <div className="menu border-right">


          {newContact.current && (
            <div className="aviso-email">
              <button style={{ border: "none", position: "absolute" }} className="aviso-email-botao" onClick={() => newContactEmail()}>
                <div className="el-center" style={{ color: "white" }}>
                  <Mail size={24} />
                </div>
              </button>
            </div>
          )}

          {/* GROUP 1 */}
          <ul>
            <li>
              <NavLink to="/">
                <div className="nav-icon">
                  <PieChart size={24} />
                </div>
                <span>Dashboard</span>
              </NavLink>
            </li>

            {[1, 2].includes(Number(user.group_id)) && (
              <li>
                <NavLink to={"chat"}>
                  <div className="nav-icon">
                    <MessageSquare size={24} />
                  </div>
                  <span>Chats Vendedores</span>
                </NavLink>
              </li>
            )}

            {user.group_id == 1 && (
              <li>
                <NavLink to={"outdated-customers-dir"}>
                  <div className="nav-icon">
                    <Users size={24} />
                  </div>
                  <span>Clientes arrematantes vencidos</span>
                </NavLink>
              </li>
            )}

            {user.group_id >= 3 && (
              <li>
                <NavLink to={"chat"}>
                  <div className="nav-icon">
                    <MessageSquare size={24} />
                  </div>
                  <span>Chats</span>
                </NavLink>
              </li>
            )}
          </ul>
          {/*  END - GROUP 1  */}

          {/* GROUP 2 */}
          {user.group_id == 1 && (
            <ul>
              <li>
                <NavLink to="/management-customers">
                  <div className="nav-icon">
                    <UserCheck size={24} />
                  </div>
                  <span>Base de Clientes</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/juridic-customers">
                  <div className="nav-icon">
                    <AlertTriangle size={24} />
                  </div>
                  <span>Inadimplentes</span>
                </NavLink>
              </li>


              <li>
                <NavLink to="contact-emails">
                  <div className="nav-icon">
                    <Mail size={24} />
                  </div>
                  <span>E-mails de contato</span>
                </NavLink>
              </li>

              <li>
                <NavLink to={"chains"}>
                  <div className="nav-icon">
                    <UserPlus size={24} />
                  </div>
                  <span>Grupo de clientes</span>
                </NavLink>
              </li>

              <li>
                <NavLink to={"condicionais"}>
                  <div className="nav-icon">
                    <UserPlus size={24} />
                  </div>
                  <span>Clientes em condicional</span>
                </NavLink>
              </li>



              {user.group_id <= 2 && (
                <li>
                  <NavLink to="vacation-tool">
                    <div className="nav-icon">
                      <Briefcase size={24} />
                    </div>
                    <span>Férias</span>
                  </NavLink>
                </li>
              )}
            </ul>
          )}

          {user.group_id == 2 && (
            <ul>
              <li>
                <NavLink to="/management-customers">
                  <div className="nav-icon">
                    <UserCheck size={24} />
                  </div>
                  <span>Base de Clientes</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/juridic-customers">
                  <div className="nav-icon">
                    <AlertTriangle size={24} />
                  </div>
                  <span>Inadimplentes</span>
                </NavLink>
              </li>


              <li>
                <NavLink to="contact-emails">
                  <div className="nav-icon">
                    <Mail size={24} />
                  </div>
                  <span>E-mails de contato</span>
                </NavLink>
              </li>

              <li>
                <NavLink to={"chains"}>
                  <div className="nav-icon">
                    <UserPlus size={24} />
                  </div>
                  <span>Grupo de clientes</span>
                </NavLink>
              </li>



              {user.group_id <= 2 && (
                <li>
                  <NavLink to="vacation-tool">
                    <div className="nav-icon">
                      <Briefcase size={24} />
                    </div>
                    <span>Férias</span>
                  </NavLink>
                </li>
              )}
            </ul>
          )}

          {user.group_id == 3 && (
            <ul>
              <li>
                <NavLink to="/customers">
                  <div className="nav-icon">
                    <Users size={24} />
                  </div>
                  <span>Meus clientes</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/new-customers">
                  <div className="nav-icon">
                    <UserPlus size={24} />
                  </div>
                  <span onClick={() => setUpdateView()}>Novos {qtdUsers > 0 ? <span style={{ color: "#F97F0C", margin: "0px" }}>({qtdUsers})</span> : ""}</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/outdated-customers">
                  <div className="nav-icon">
                    <UserX size={24} />
                  </div>
                  <span>Clientes gerais</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/ranking">
                  <div className="nav-icon">
                    <BarChart2 size={24} />
                  </div>
                  <span>Ranking</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="favorited-lots">
                  <div className="nav-icon">
                    <Star size={24} />
                  </div>
                  <span>Lotes favoritados</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/access-reports">
                  <div className="nav-icon">
                    <BookOpen size={24} />
                  </div>
                  <span>Relatório de Acessos</span>
                </NavLink>
              </li>
            </ul>
          )}

          {user.group_id == 8 && (
            <ul>
              <li>
                <NavLink to="/customers">
                  <div className="nav-icon">
                    <Users size={24} />
                  </div>
                  <span>Meus clientes</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/outdated-customers">
                  <div className="nav-icon">
                    <UserX size={24} />
                  </div>
                  <span>Clientes gerais</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/management-customers/prospect">
                  <div className="nav-icon">
                    <Send size={24} />
                  </div>
                  <span>Transferências Prospect</span>
                </NavLink>
              </li>
            </ul>
          )}

          {user.group_id == 11 && (
            <ul>
              <li>
                <NavLink to="/customers">
                  <div className="nav-icon">
                    <Users size={24} />
                  </div>
                  <span>Meus clientes</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/new-customers">
                  <div className="nav-icon">
                    <UserPlus size={24} />
                  </div>
                  <span onClick={() => setUpdateView()}>Novos {qtdUsers > 0 ? <span style={{ color: "#F97F0C", margin: "0px" }}>({qtdUsers})</span> : ""}</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/outdated-customers">
                  <div className="nav-icon">
                    <UserX size={24} />
                  </div>
                  <span>Clientes gerais</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/ranking">
                  <div className="nav-icon">
                    <Star size={24} />
                  </div>
                  <span>Ranking</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/access-reports">
                  <div className="nav-icon">
                    <BookOpen size={24} />
                  </div>
                  <span>Relatório de Acessos</span>
                </NavLink>
              </li>
            </ul>
          )}
          {/*  END - GROUP 2  */}

          {/* GROUP 3 */}
          <ul>
            <li>
              <NavLink to="account">
                <div className="nav-icon">
                  <User size={24} />
                </div>
                <span>Minha conta</span>
              </NavLink>
            </li>

            {user.group_id > 2 && (
              <li>
                <NavLink to="utils/tags">
                  <div className="nav-icon">
                    <Edit2 size={24} />
                  </div>
                  <span>Utilitários</span>
                </NavLink>
              </li>
            )}

            <li>
              <a href="#" onClick={handleSignOut}>
                <div className="nav-icon">
                  <Power size={24} />
                </div>
                <span>Sair</span>
              </a>
            </li>

            <li>
              <a className="w-100">
                <div className="nav-icon">
                  <Moon size={24} />
                </div>
                <div className="d-flex flex-row align-center justify-content-between w-100">
                  <span className="">Tema escuro</span>
                  <div className="mt-sm">
                    <SwitchCheckbox darkSwitch={true} onChange={switchTheme} checked={theme === "dark" ? true : false} />
                  </div>
                </div>
              </a>
            </li>
          </ul>
          {/*  END - GROUP 3  */}

          {/* <button type="button" className="floating-bttn" onClick={() => setTrigger(!trigger)}>
            <div className="floating-bttn__alert"></div>
            <Gavel />
          </button> */}
        </div>

        <div className="menu-footer">
          {user.group_id > 1 && <Todo />}
          <ErrorInternet />
        </div>
      </div>

      <div className="content">
        {props.children}
      </div>

    </div >
  );
}

export default Template;
